// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  AdminAddGroupAppRoleData,
  AdminAddGroupAppRoleErrors,
  AdminAddGroupAppRoleResponses,
  AdminAddGroupTenantData,
  AdminAddGroupTenantErrors,
  AdminAddGroupTenantResponses,
  AdminAddPackageToProjectData,
  AdminAddPackageToProjectErrors,
  AdminAddPackageToProjectResponses,
  AdminAddProjectData,
  AdminAddProjectErrors,
  AdminAddProjectResponses,
  AdminAddProjectRoleOfUserData,
  AdminAddProjectRoleOfUserErrors,
  AdminAddProjectRoleOfUserResponses,
  AdminAddProjectToGroupData,
  AdminAddProjectToGroupErrors,
  AdminAddProjectToGroupResponses,
  AdminAddRoleToGroupData,
  AdminAddRoleToGroupErrors,
  AdminAddRoleToGroupResponses,
  AdminAddUserToGroupData,
  AdminAddUserToGroupErrors,
  AdminAddUserToGroupResponses,
  AdminAddUserToProjectData,
  AdminAddUserToProjectErrors,
  AdminAddUserToProjectResponses,
  AdminChangeGroupAppRoleData,
  AdminChangeGroupAppRoleErrors,
  AdminChangeGroupAppRoleResponses,
  AdminChangeGroupScopeTypeData,
  AdminChangeGroupScopeTypeErrors,
  AdminChangeGroupScopeTypeResponses,
  AdminChangeProjectRoleOfUserData,
  AdminChangeProjectRoleOfUserErrors,
  AdminChangeProjectRoleOfUserResponses,
  AdminChangeUserScopeTypeData,
  AdminChangeUserScopeTypeErrors,
  AdminChangeUserScopeTypeResponses,
  AdminCreateGroupData,
  AdminCreateGroupErrors,
  AdminCreateGroupResponses,
  AdminCreateUserData,
  AdminCreateUserErrors,
  AdminCreateUserResponses,
  AdminDeleteGroupAppRoleData,
  AdminDeleteGroupAppRoleErrors,
  AdminDeleteGroupAppRoleResponses,
  AdminDeleteGroupData,
  AdminDeleteGroupErrors,
  AdminDeleteGroupFromProjectData,
  AdminDeleteGroupFromProjectErrors,
  AdminDeleteGroupFromProjectResponses,
  AdminDeleteGroupResponses,
  AdminDeleteUserData,
  AdminDeleteUserErrors,
  AdminDeleteUserFromProjectData,
  AdminDeleteUserFromProjectErrors,
  AdminDeleteUserFromProjectResponses,
  AdminDeleteUserResponses,
  AdminGetDomainsData,
  AdminGetDomainsErrors,
  AdminGetDomainsResponses,
  AdminGetGroupData,
  AdminGetGroupErrors,
  AdminGetGroupResponses,
  AdminGetGroupsData,
  AdminGetGroupsErrors,
  AdminGetGroupsResponses,
  AdminGetUserData,
  AdminGetUserDataData,
  AdminGetUserDataErrors,
  AdminGetUserDataResponses,
  AdminGetUserDetailsProjectsData,
  AdminGetUserDetailsProjectsErrors,
  AdminGetUserDetailsProjectsResponses,
  AdminGetUserErrors,
  AdminGetUserProjectsUpData,
  AdminGetUserProjectsUpErrors,
  AdminGetUserProjectsUpResponses,
  AdminGetUserResponses,
  AdminGetUserRolesUpData,
  AdminGetUserRolesUpErrors,
  AdminGetUserRolesUpResponses,
  AdminRemoveAdminRoleFromGroupData,
  AdminRemoveAdminRoleFromGroupErrors,
  AdminRemoveAdminRoleFromGroupResponses,
  AdminRemoveGroupTenantData,
  AdminRemoveGroupTenantErrors,
  AdminRemoveGroupTenantResponses,
  AdminRemovePackageFromProjectData,
  AdminRemovePackageFromProjectErrors,
  AdminRemovePackageFromProjectResponses,
  AdminRemoveProjectRoleOfUserData,
  AdminRemoveProjectRoleOfUserErrors,
  AdminRemoveProjectRoleOfUserResponses,
  AdminRemoveUserFromGroupData,
  AdminRemoveUserFromGroupErrors,
  AdminRemoveUserFromGroupResponses,
  AdminRemoveUserRoleData,
  AdminRemoveUserRoleErrors,
  AdminRemoveUserRoleResponses,
  AdminRequestPasswordResetData,
  AdminRequestPasswordResetErrors,
  AdminRequestPasswordResetResponses,
  AdminUpdateGroupData,
  AdminUpdateGroupErrors,
  AdminUpdateGroupResponses,
  AdminUpdateProjectData,
  AdminUpdateProjectErrors,
  AdminUpdateProjectResponses,
  AdminUpdateRoleInGroupData,
  AdminUpdateRoleInGroupErrors,
  AdminUpdateRoleInGroupResponses,
  AdminUpdateUserData,
  AdminUpdateUserErrors,
  AdminUpdateUserResponses,
  AdminUpdateUserRoleData,
  AdminUpdateUserRoleErrors,
  AdminUpdateUserRoleResponses,
  AdminUsersCreateAdminUserData,
  AdminUsersCreateAdminUserErrors,
  AdminUsersCreateAdminUserResponses,
  AdminUsersGetAdminUserData,
  AdminUsersGetAdminUserErrors,
  AdminUsersGetAdminUserResponses,
  AdminUsersGetMyAdminDataData,
  AdminUsersGetMyAdminDataErrors,
  AdminUsersGetMyAdminDataResponses,
  AdminUsersListAdminUsersData,
  AdminUsersListAdminUsersErrors,
  AdminUsersListAdminUsersResponses,
  AdminUsersRevokeAdminAccessData,
  AdminUsersRevokeAdminAccessErrors,
  AdminUsersRevokeAdminAccessResponses,
  AdminUsersUpdateAdminUserData,
  AdminUsersUpdateAdminUserErrors,
  AdminUsersUpdateAdminUserResponses,
  AuthzCheckAccessData,
  AuthzCheckAccessErrors,
  AuthzCheckAccessResponses,
  AuthzPermissionsData,
  AuthzPermissionsErrors,
  AuthzPermissionsResponses,
  AuthzPlanData,
  AuthzPlanErrors,
  AuthzPlanResponses,
  DomainsGetAllAppsData,
  DomainsGetAllAppsErrors,
  DomainsGetAllAppsResponses,
  EdifyPackagesGetEdifyPackagesData,
  EdifyPackagesGetEdifyPackagesErrors,
  EdifyPackagesGetEdifyPackagesResponses,
  EdifyPackagesGetProjectByPackageIdData,
  EdifyPackagesGetProjectByPackageIdErrors,
  EdifyPackagesGetProjectByPackageIdResponses,
  EdifyPackagesSearchEdifyPackagesData,
  EdifyPackagesSearchEdifyPackagesErrors,
  EdifyPackagesSearchEdifyPackagesResponses,
  GroupsAddGroupTenantData,
  GroupsAddGroupTenantErrors,
  GroupsAddGroupTenantResponses,
  GroupsAddRoleToGroupData,
  GroupsAddRoleToGroupErrors,
  GroupsAddRoleToGroupResponses,
  GroupsAddUserToGroupData,
  GroupsAddUserToGroupErrors,
  GroupsAddUserToGroupResponses,
  GroupsChangeGroupScopeTypeData,
  GroupsChangeGroupScopeTypeErrors,
  GroupsChangeGroupScopeTypeResponses,
  GroupsCreateGroupData,
  GroupsCreateGroupErrors,
  GroupsCreateGroupResponses,
  GroupsDeleteGroupData,
  GroupsDeleteGroupErrors,
  GroupsDeleteGroupResponses,
  GroupsGetGroupByIdData,
  GroupsGetGroupByIdErrors,
  GroupsGetGroupByIdResponses,
  GroupsGetGroupsData,
  GroupsGetGroupsErrors,
  GroupsGetGroupsResponses,
  GroupsRemoveGroupTenantData,
  GroupsRemoveGroupTenantErrors,
  GroupsRemoveGroupTenantResponses,
  GroupsRemoveRoleFromGroupData,
  GroupsRemoveRoleFromGroupErrors,
  GroupsRemoveRoleFromGroupResponses,
  GroupsRemoveUserFromGroupData,
  GroupsRemoveUserFromGroupErrors,
  GroupsRemoveUserFromGroupResponses,
  GroupsUpdateGroupData,
  GroupsUpdateGroupErrors,
  GroupsUpdateGroupResponses,
  GroupsUpdateRoleInGroupData,
  GroupsUpdateRoleInGroupErrors,
  GroupsUpdateRoleInGroupResponses,
  ProjectsAddPackageToProjectData,
  ProjectsAddPackageToProjectErrors,
  ProjectsAddPackageToProjectResponses,
  ProjectsAddProjectData,
  ProjectsAddProjectErrors,
  ProjectsAddProjectResponses,
  ProjectsAddProjectRoleOfUserData,
  ProjectsAddProjectRoleOfUserErrors,
  ProjectsAddProjectRoleOfUserResponses,
  ProjectsAddUserToProjectData,
  ProjectsAddUserToProjectErrors,
  ProjectsAddUserToProjectResponses,
  ProjectsBulkGetProjectsByIdsData,
  ProjectsBulkGetProjectsByIdsErrors,
  ProjectsBulkGetProjectsByIdsResponses,
  ProjectsChangeProjectRoleOfUserData,
  ProjectsChangeProjectRoleOfUserErrors,
  ProjectsChangeProjectRoleOfUserResponses,
  ProjectsDeleteGroupFromProjectData,
  ProjectsDeleteGroupFromProjectErrors,
  ProjectsDeleteGroupFromProjectResponses,
  ProjectsDeleteUserFromProjectData,
  ProjectsDeleteUserFromProjectErrors,
  ProjectsDeleteUserFromProjectResponses,
  ProjectsGetProjectByIdData,
  ProjectsGetProjectByIdErrors,
  ProjectsGetProjectByIdResponses,
  ProjectsGetProjectEntitiesData,
  ProjectsGetProjectEntitiesErrors,
  ProjectsGetProjectEntitiesResponses,
  ProjectsGetProjectPackagesData,
  ProjectsGetProjectPackagesErrors,
  ProjectsGetProjectPackagesResponses,
  ProjectsGetProjectsData,
  ProjectsGetProjectsErrors,
  ProjectsGetProjectsResponses,
  ProjectsGetProjectUsersByAppData,
  ProjectsGetProjectUsersByAppErrors,
  ProjectsGetProjectUsersByAppResponses,
  ProjectsGetProjectUsersData,
  ProjectsGetProjectUsersErrors,
  ProjectsGetProjectUsersResponses,
  ProjectsGetUserProjectRolesData,
  ProjectsGetUserProjectRolesErrors,
  ProjectsGetUserProjectRolesResponses,
  ProjectsRemovePackageFromProjectData,
  ProjectsRemovePackageFromProjectErrors,
  ProjectsRemovePackageFromProjectResponses,
  ProjectsRemoveProjectRoleOfUserData,
  ProjectsRemoveProjectRoleOfUserErrors,
  ProjectsRemoveProjectRoleOfUserResponses,
  ProjectsUpdateProjectData,
  ProjectsUpdateProjectErrors,
  ProjectsUpdateProjectResponses,
  RolesGetAllRolesData,
  RolesGetAllRolesErrors,
  RolesGetAllRolesResponses,
  ServiceApiPackagesGetProjectByPackageIdData,
  ServiceApiPackagesGetProjectByPackageIdErrors,
  ServiceApiPackagesGetProjectByPackageIdResponses,
  TenantsGetAllTenantsData,
  TenantsGetAllTenantsErrors,
  TenantsGetAllTenantsResponses,
  UsersBulkGetUsersData,
  UsersBulkGetUsersErrors,
  UsersBulkGetUsersResponses,
  UsersChangeUserScopeTypeData,
  UsersChangeUserScopeTypeErrors,
  UsersChangeUserScopeTypeResponses,
  UsersCreateUserData,
  UsersCreateUserErrors,
  UsersCreateUserResponses,
  UsersDeleteUserData,
  UsersDeleteUserErrors,
  UsersDeleteUserResponses,
  UsersGetUserByIdData,
  UsersGetUserByIdErrors,
  UsersGetUserByIdResponses,
  UsersGetUserGroupsData,
  UsersGetUserGroupsErrors,
  UsersGetUserGroupsResponses,
  UsersGetUserKeyringsData,
  UsersGetUserKeyringsErrors,
  UsersGetUserKeyringsResponses,
  UsersGetUserPackageIdsData,
  UsersGetUserPackageIdsErrors,
  UsersGetUserPackageIdsResponses,
  UsersGetUserProjectsData,
  UsersGetUserProjectsErrors,
  UsersGetUserProjectsResponses,
  UsersGetUserRolesData,
  UsersGetUserRolesErrors,
  UsersGetUserRolesResponses,
  UsersGetUsersData,
  UsersGetUsersErrors,
  UsersGetUsersResponses,
  UsersMeData,
  UsersMeErrors,
  UsersMeResponses,
  UsersRemoveUserRoleData,
  UsersRemoveUserRoleErrors,
  UsersRemoveUserRoleResponses,
  UsersRequestPasswordResetData,
  UsersRequestPasswordResetErrors,
  UsersRequestPasswordResetResponses,
  UsersSearchGraphUsersData,
  UsersSearchGraphUsersErrors,
  UsersSearchGraphUsersResponses,
  UsersSearchUdbUsersData,
  UsersSearchUdbUsersErrors,
  UsersSearchUdbUsersResponses,
  UsersUpdateUserData,
  UsersUpdateUserErrors,
  UsersUpdateUserResponses,
  UsersUpdateUserRoleData,
  UsersUpdateUserRoleErrors,
  UsersUpdateUserRoleResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Get all projects, optionally with packages and filtered by tenantId
 */
export const projectsGetProjects = <ThrowOnError extends boolean = true>(
  options?: Options<ProjectsGetProjectsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ProjectsGetProjectsResponses,
    ProjectsGetProjectsErrors,
    ThrowOnError
  >({ url: "/api/projects", ...options });

/**
 * [DEPRECATED] Add project
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/projects instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsAddProject = <ThrowOnError extends boolean = true>(
  options?: Options<ProjectsAddProjectData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    ProjectsAddProjectResponses,
    ProjectsAddProjectErrors,
    ThrowOnError
  >({
    url: "/api/projects",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Get specific projects by IDs with packages
 */
export const projectsBulkGetProjectsByIds = <ThrowOnError extends boolean = true>(
  options?: Options<ProjectsBulkGetProjectsByIdsData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    ProjectsBulkGetProjectsByIdsResponses,
    ProjectsBulkGetProjectsByIdsErrors,
    ThrowOnError
  >({
    url: "/api/projects/bulk",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Get project by ID
 */
export const projectsGetProjectById = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsGetProjectByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProjectsGetProjectByIdResponses,
    ProjectsGetProjectByIdErrors,
    ThrowOnError
  >({ url: "/api/projects/{id}", ...options });

/**
 * [DEPRECATED] Update project
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use PUT /api/admin/projects/:id instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsUpdateProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsUpdateProjectData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    ProjectsUpdateProjectResponses,
    ProjectsUpdateProjectErrors,
    ThrowOnError
  >({
    url: "/api/projects/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get users assigned to project
 */
export const projectsGetProjectUsers = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsGetProjectUsersData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProjectsGetProjectUsersResponses,
    ProjectsGetProjectUsersErrors,
    ThrowOnError
  >({ url: "/api/projects/{id}/users", ...options });

/**
 * Get users assigned to project filtered by app, including role information
 */
export const projectsGetProjectUsersByApp = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsGetProjectUsersByAppData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProjectsGetProjectUsersByAppResponses,
    ProjectsGetProjectUsersByAppErrors,
    ThrowOnError
  >({ url: "/api/projects/{projectId}/apps/{appId}/users", ...options });

/**
 * Get packages in project
 */
export const projectsGetProjectPackages = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsGetProjectPackagesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProjectsGetProjectPackagesResponses,
    ProjectsGetProjectPackagesErrors,
    ThrowOnError
  >({ url: "/api/projects/{id}/packages", ...options });

/**
 * [DEPRECATED] Remove package from project
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/projects/:projectId/packages instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsRemovePackageFromProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsRemovePackageFromProjectData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ProjectsRemovePackageFromProjectResponses,
    ProjectsRemovePackageFromProjectErrors,
    ThrowOnError
  >({
    url: "/api/projects/{projectId}/packages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add package to project (Used by Edify)
 */
export const projectsAddPackageToProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsAddPackageToProjectData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProjectsAddPackageToProjectResponses,
    ProjectsAddPackageToProjectErrors,
    ThrowOnError
  >({
    url: "/api/projects/{projectId}/packages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Delete user from project
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/projects/:projectId/users instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsDeleteUserFromProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsDeleteUserFromProjectData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ProjectsDeleteUserFromProjectResponses,
    ProjectsDeleteUserFromProjectErrors,
    ThrowOnError
  >({
    url: "/api/projects/{projectId}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Add user to project
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/projects/:projectId/users instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsAddUserToProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsAddUserToProjectData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProjectsAddUserToProjectResponses,
    ProjectsAddUserToProjectErrors,
    ThrowOnError
  >({
    url: "/api/projects/{projectId}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Delete group from project
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/projects/:projectId/groups instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsDeleteGroupFromProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsDeleteGroupFromProjectData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ProjectsDeleteGroupFromProjectResponses,
    ProjectsDeleteGroupFromProjectErrors,
    ThrowOnError
  >({
    url: "/api/projects/{projectId}/groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Remove project role from user
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/projects/:projectId/users/:userId instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsRemoveProjectRoleOfUser = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsRemoveProjectRoleOfUserData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ProjectsRemoveProjectRoleOfUserResponses,
    ProjectsRemoveProjectRoleOfUserErrors,
    ThrowOnError
  >({
    url: "/api/projects/{projectId}/users/{userId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Add project role to user
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/projects/:projectId/users/:userId instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsAddProjectRoleOfUser = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsAddProjectRoleOfUserData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProjectsAddProjectRoleOfUserResponses,
    ProjectsAddProjectRoleOfUserErrors,
    ThrowOnError
  >({
    url: "/api/projects/{projectId}/users/{userId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Change project role of user
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use PUT /api/admin/projects/:projectId/users/:userId instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsChangeProjectRoleOfUser = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsChangeProjectRoleOfUserData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    ProjectsChangeProjectRoleOfUserResponses,
    ProjectsChangeProjectRoleOfUserErrors,
    ThrowOnError
  >({
    url: "/api/projects/{projectId}/users/{userId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get user project roles by project ID
 */
export const projectsGetUserProjectRoles = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsGetUserProjectRolesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProjectsGetUserProjectRolesResponses,
    ProjectsGetUserProjectRolesErrors,
    ThrowOnError
  >({ url: "/api/projects/{projectId}/users/{sub}/roles", ...options });

/**
 * Get entities (users and groups) for a certain role assigned to project ID
 */
export const projectsGetProjectEntities = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsGetProjectEntitiesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProjectsGetProjectEntitiesResponses,
    ProjectsGetProjectEntitiesErrors,
    ThrowOnError
  >({ url: "/api/projects/{projectId}/withRole/{roleName}", ...options });

/**
 * Get logged in user information
 */
export const usersMe = <ThrowOnError extends boolean = true>(
  options?: Options<UsersMeData, ThrowOnError>,
) =>
  (options?.client ?? client).get<UsersMeResponses, UsersMeErrors, ThrowOnError>({
    url: "/api/users/me",
    ...options,
  });

/**
 * Get all users
 */
export const usersGetUsers = <ThrowOnError extends boolean = true>(
  options?: Options<UsersGetUsersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<UsersGetUsersResponses, UsersGetUsersErrors, ThrowOnError>({
    url: "/api/users",
    ...options,
  });

/**
 * [DEPRECATED] Create new user
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/users instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const usersCreateUser = <ThrowOnError extends boolean = true>(
  options?: Options<UsersCreateUserData, ThrowOnError>,
) =>
  (options?.client ?? client).post<UsersCreateUserResponses, UsersCreateUserErrors, ThrowOnError>({
    url: "/api/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * [DEPRECATED] Delete user
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/users/:sub instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const usersDeleteUser = <ThrowOnError extends boolean = true>(
  options: Options<UsersDeleteUserData, ThrowOnError>,
) =>
  (options.client ?? client).delete<UsersDeleteUserResponses, UsersDeleteUserErrors, ThrowOnError>({
    url: "/api/users/{sub}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get user by ID
 */
export const usersGetUserById = <ThrowOnError extends boolean = true>(
  options: Options<UsersGetUserByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<UsersGetUserByIdResponses, UsersGetUserByIdErrors, ThrowOnError>({
    url: "/api/users/{sub}",
    ...options,
  });

/**
 * [DEPRECATED] Update user
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use PUT /api/admin/users/:sub instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const usersUpdateUser = <ThrowOnError extends boolean = true>(
  options: Options<UsersUpdateUserData, ThrowOnError>,
) =>
  (options.client ?? client).put<UsersUpdateUserResponses, UsersUpdateUserErrors, ThrowOnError>({
    url: "/api/users/{sub}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Remove user role
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/users/:sub/roles instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const usersRemoveUserRole = <ThrowOnError extends boolean = true>(
  options: Options<UsersRemoveUserRoleData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    UsersRemoveUserRoleResponses,
    UsersRemoveUserRoleErrors,
    ThrowOnError
  >({
    url: "/api/users/{sub}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get user roles
 */
export const usersGetUserRoles = <ThrowOnError extends boolean = true>(
  options: Options<UsersGetUserRolesData, ThrowOnError>,
) =>
  (options.client ?? client).get<UsersGetUserRolesResponses, UsersGetUserRolesErrors, ThrowOnError>(
    { url: "/api/users/{sub}/roles", ...options },
  );

/**
 * [DEPRECATED] Update user role
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use PUT /api/admin/users/:sub/roles instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const usersUpdateUserRole = <ThrowOnError extends boolean = true>(
  options: Options<UsersUpdateUserRoleData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UsersUpdateUserRoleResponses,
    UsersUpdateUserRoleErrors,
    ThrowOnError
  >({
    url: "/api/users/{sub}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get user's projects
 */
export const usersGetUserProjects = <ThrowOnError extends boolean = true>(
  options: Options<UsersGetUserProjectsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    UsersGetUserProjectsResponses,
    UsersGetUserProjectsErrors,
    ThrowOnError
  >({ url: "/api/users/{sub}/projects", ...options });

/**
 * Get user's package IDs
 */
export const usersGetUserPackageIds = <ThrowOnError extends boolean = true>(
  options: Options<UsersGetUserPackageIdsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    UsersGetUserPackageIdsResponses,
    UsersGetUserPackageIdsErrors,
    ThrowOnError
  >({ url: "/api/users/{sub}/package-ids", ...options });

/**
 * Get user's groups
 */
export const usersGetUserGroups = <ThrowOnError extends boolean = true>(
  options: Options<UsersGetUserGroupsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    UsersGetUserGroupsResponses,
    UsersGetUserGroupsErrors,
    ThrowOnError
  >({ url: "/api/users/{sub}/groups", ...options });

/**
 * Get user keyrings
 */
export const usersGetUserKeyrings = <ThrowOnError extends boolean = true>(
  options: Options<UsersGetUserKeyringsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    UsersGetUserKeyringsResponses,
    UsersGetUserKeyringsErrors,
    ThrowOnError
  >({ url: "/api/users/{sub}/keyrings", ...options });

/**
 * Search for users in Graph
 */
export const usersSearchGraphUsers = <ThrowOnError extends boolean = true>(
  options: Options<UsersSearchGraphUsersData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    UsersSearchGraphUsersResponses,
    UsersSearchGraphUsersErrors,
    ThrowOnError
  >({ url: "/api/users/search/graph", ...options });

/**
 * [DEPRECATED] Request external user password reset
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/users/:sub/password-reset instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const usersRequestPasswordReset = <ThrowOnError extends boolean = true>(
  options: Options<UsersRequestPasswordResetData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UsersRequestPasswordResetResponses,
    UsersRequestPasswordResetErrors,
    ThrowOnError
  >({
    url: "/api/users/{sub}/password-reset",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Search UDB users
 */
export const usersSearchUdbUsers = <ThrowOnError extends boolean = true>(
  options: Options<UsersSearchUdbUsersData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    UsersSearchUdbUsersResponses,
    UsersSearchUdbUsersErrors,
    ThrowOnError
  >({ url: "/api/users/search/udb", ...options });

/**
 * [DEPRECATED] Change user scope type
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use PUT /api/admin/users/:sub/scope-type instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const usersChangeUserScopeType = <ThrowOnError extends boolean = true>(
  options: Options<UsersChangeUserScopeTypeData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UsersChangeUserScopeTypeResponses,
    UsersChangeUserScopeTypeErrors,
    ThrowOnError
  >({
    url: "/api/users/{sub}/scope-type",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get multiple users by subs
 */
export const usersBulkGetUsers = <ThrowOnError extends boolean = true>(
  options?: Options<UsersBulkGetUsersData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    UsersBulkGetUsersResponses,
    UsersBulkGetUsersErrors,
    ThrowOnError
  >({
    url: "/api/users/bulk",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

export const tenantsGetAllTenants = <ThrowOnError extends boolean = true>(
  options?: Options<TenantsGetAllTenantsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    TenantsGetAllTenantsResponses,
    TenantsGetAllTenantsErrors,
    ThrowOnError
  >({ url: "/api/tenants", ...options });

export const domainsGetAllApps = <ThrowOnError extends boolean = true>(
  options?: Options<DomainsGetAllAppsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    DomainsGetAllAppsResponses,
    DomainsGetAllAppsErrors,
    ThrowOnError
  >({ url: "/api/domains", ...options });

export const rolesGetAllRoles = <ThrowOnError extends boolean = true>(
  options?: Options<RolesGetAllRolesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<RolesGetAllRolesResponses, RolesGetAllRolesErrors, ThrowOnError>({
    url: "/api/roles",
    ...options,
  });

/**
 * Get all Edify Packages
 */
export const edifyPackagesGetEdifyPackages = <ThrowOnError extends boolean = true>(
  options?: Options<EdifyPackagesGetEdifyPackagesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    EdifyPackagesGetEdifyPackagesResponses,
    EdifyPackagesGetEdifyPackagesErrors,
    ThrowOnError
  >({ url: "/api/edify/packages", ...options });

/**
 * Search Edify packages with query string
 */
export const edifyPackagesSearchEdifyPackages = <ThrowOnError extends boolean = true>(
  options: Options<EdifyPackagesSearchEdifyPackagesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    EdifyPackagesSearchEdifyPackagesResponses,
    EdifyPackagesSearchEdifyPackagesErrors,
    ThrowOnError
  >({ url: "/api/edify/packages/packageSearch/{pageNum}", ...options });

/**
 * Get project by package id
 */
export const edifyPackagesGetProjectByPackageId = <ThrowOnError extends boolean = true>(
  options: Options<EdifyPackagesGetProjectByPackageIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    EdifyPackagesGetProjectByPackageIdResponses,
    EdifyPackagesGetProjectByPackageIdErrors,
    ThrowOnError
  >({ url: "/api/packages/{packageId}/project", ...options });

/**
 * Get project by package id (Service-to-service endpoint)
 */
export const serviceApiPackagesGetProjectByPackageId = <ThrowOnError extends boolean = true>(
  options: Options<ServiceApiPackagesGetProjectByPackageIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ServiceApiPackagesGetProjectByPackageIdResponses,
    ServiceApiPackagesGetProjectByPackageIdErrors,
    ThrowOnError
  >({ url: "/service-api/packages/{packageId}/project", ...options });

export const authzCheckAccess = <ThrowOnError extends boolean = true>(
  options?: Options<AuthzCheckAccessData, ThrowOnError>,
) =>
  (options?.client ?? client).post<AuthzCheckAccessResponses, AuthzCheckAccessErrors, ThrowOnError>(
    {
      url: "/api/authz/check-access",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    },
  );

export const authzPermissions = <ThrowOnError extends boolean = true>(
  options?: Options<AuthzPermissionsData, ThrowOnError>,
) =>
  (options?.client ?? client).post<AuthzPermissionsResponses, AuthzPermissionsErrors, ThrowOnError>(
    {
      url: "/api/authz/permissions",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    },
  );

export const authzPlan = <ThrowOnError extends boolean = true>(
  options?: Options<AuthzPlanData, ThrowOnError>,
) =>
  (options?.client ?? client).post<AuthzPlanResponses, AuthzPlanErrors, ThrowOnError>({
    url: "/api/authz/plan",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Get all groups
 */
export const groupsGetGroups = <ThrowOnError extends boolean = true>(
  options?: Options<GroupsGetGroupsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GroupsGetGroupsResponses, GroupsGetGroupsErrors, ThrowOnError>({
    url: "/api/groups",
    ...options,
  });

/**
 * [DEPRECATED] Create group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/groups instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsCreateGroup = <ThrowOnError extends boolean = true>(
  options?: Options<GroupsCreateGroupData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    GroupsCreateGroupResponses,
    GroupsCreateGroupErrors,
    ThrowOnError
  >({
    url: "/api/groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * [DEPRECATED] Delete group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/groups/:id instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsDeleteGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsDeleteGroupData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    GroupsDeleteGroupResponses,
    GroupsDeleteGroupErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get group by ID
 */
export const groupsGetGroupById = <ThrowOnError extends boolean = true>(
  options: Options<GroupsGetGroupByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GroupsGetGroupByIdResponses,
    GroupsGetGroupByIdErrors,
    ThrowOnError
  >({ url: "/api/groups/{id}", ...options });

/**
 * [DEPRECATED] Update group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use PUT /api/admin/groups/:id instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsUpdateGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsUpdateGroupData, ThrowOnError>,
) =>
  (options.client ?? client).put<GroupsUpdateGroupResponses, GroupsUpdateGroupErrors, ThrowOnError>(
    {
      url: "/api/groups/{id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
  );

/**
 * [DEPRECATED] Remove tenant from group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/groups/:id/tenants instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsRemoveGroupTenant = <ThrowOnError extends boolean = true>(
  options: Options<GroupsRemoveGroupTenantData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    GroupsRemoveGroupTenantResponses,
    GroupsRemoveGroupTenantErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Add tenant to group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/groups/:id/tenants instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsAddGroupTenant = <ThrowOnError extends boolean = true>(
  options: Options<GroupsAddGroupTenantData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GroupsAddGroupTenantResponses,
    GroupsAddGroupTenantErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Remove user from group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/groups/:id/users instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsRemoveUserFromGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsRemoveUserFromGroupData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    GroupsRemoveUserFromGroupResponses,
    GroupsRemoveUserFromGroupErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Add user to group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/groups/:id/users instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsAddUserToGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsAddUserToGroupData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GroupsAddUserToGroupResponses,
    GroupsAddUserToGroupErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Remove role from group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/groups/:id/roles instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsRemoveRoleFromGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsRemoveRoleFromGroupData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    GroupsRemoveRoleFromGroupResponses,
    GroupsRemoveRoleFromGroupErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Add role to group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/groups/:id/roles instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsAddRoleToGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsAddRoleToGroupData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GroupsAddRoleToGroupResponses,
    GroupsAddRoleToGroupErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Update role in group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use PUT /api/admin/groups/:id/roles instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsUpdateRoleInGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsUpdateRoleInGroupData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    GroupsUpdateRoleInGroupResponses,
    GroupsUpdateRoleInGroupErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Change group scope type
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use PUT /api/admin/groups/:id/scope-type instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsChangeGroupScopeType = <ThrowOnError extends boolean = true>(
  options: Options<GroupsChangeGroupScopeTypeData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    GroupsChangeGroupScopeTypeResponses,
    GroupsChangeGroupScopeTypeErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}/scope-type",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get user roles, filtered by active roles
 */
export const adminGetUserRolesUp = <ThrowOnError extends boolean = true>(
  options: Options<AdminGetUserRolesUpData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    AdminGetUserRolesUpResponses,
    AdminGetUserRolesUpErrors,
    ThrowOnError
  >({ url: "/api/admin/users/{userSub}/roles", ...options });

/**
 * Get user's projects, filtered by appId and only return active projects
 */
export const adminGetUserProjectsUp = <ThrowOnError extends boolean = true>(
  options: Options<AdminGetUserProjectsUpData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    AdminGetUserProjectsUpResponses,
    AdminGetUserProjectsUpErrors,
    ThrowOnError
  >({ url: "/api/admin/users/{userSub}/projects", ...options });

/**
 * Get user projects for user details page
 */
export const adminGetUserDetailsProjects = <ThrowOnError extends boolean = true>(
  options: Options<AdminGetUserDetailsProjectsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    AdminGetUserDetailsProjectsResponses,
    AdminGetUserDetailsProjectsErrors,
    ThrowOnError
  >({ url: "/api/admin/users/{userSub}/details", ...options });

/**
 * Get all available domains
 */
export const adminGetDomains = <ThrowOnError extends boolean = true>(
  options?: Options<AdminGetDomainsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<AdminGetDomainsResponses, AdminGetDomainsErrors, ThrowOnError>({
    url: "/api/admin/domains",
    ...options,
  });

/**
 * Get all groups, optionally filtered by opco
 */
export const adminGetGroups = <ThrowOnError extends boolean = true>(
  options?: Options<AdminGetGroupsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<AdminGetGroupsResponses, AdminGetGroupsErrors, ThrowOnError>({
    url: "/api/admin/groups",
    ...options,
  });

/**
 * Create group
 */
export const adminCreateGroup = <ThrowOnError extends boolean = true>(
  options?: Options<AdminCreateGroupData, ThrowOnError>,
) =>
  (options?.client ?? client).post<AdminCreateGroupResponses, AdminCreateGroupErrors, ThrowOnError>(
    {
      url: "/api/admin/groups",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    },
  );

/**
 * Delete group
 *
 * Deletes a group. Requires admin access.
 */
export const adminDeleteGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminDeleteGroupData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    AdminDeleteGroupResponses,
    AdminDeleteGroupErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get a group by ID
 */
export const adminGetGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminGetGroupData, ThrowOnError>,
) =>
  (options.client ?? client).get<AdminGetGroupResponses, AdminGetGroupErrors, ThrowOnError>({
    url: "/api/admin/groups/{groupId}",
    ...options,
  });

/**
 * Update a group's name and tenants
 */
export const adminUpdateGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminUpdateGroupData, ThrowOnError>,
) =>
  (options.client ?? client).put<AdminUpdateGroupResponses, AdminUpdateGroupErrors, ThrowOnError>({
    url: "/api/admin/groups/{groupId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove a user from a group
 */
export const adminRemoveUserFromGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminRemoveUserFromGroupData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    AdminRemoveUserFromGroupResponses,
    AdminRemoveUserFromGroupErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add a user to a group
 */
export const adminAddUserToGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminAddUserToGroupData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminAddUserToGroupResponses,
    AdminAddUserToGroupErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add a project to a group, with default roles
 */
export const adminAddProjectToGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminAddProjectToGroupData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminAddProjectToGroupResponses,
    AdminAddProjectToGroupErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/project",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add an app role to a group
 */
export const adminAddGroupAppRole = <ThrowOnError extends boolean = true>(
  options: Options<AdminAddGroupAppRoleData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminAddGroupAppRoleResponses,
    AdminAddGroupAppRoleErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/add-app-role",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Removes an app role from a group
 */
export const adminDeleteGroupAppRole = <ThrowOnError extends boolean = true>(
  options: Options<AdminDeleteGroupAppRoleData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminDeleteGroupAppRoleResponses,
    AdminDeleteGroupAppRoleErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/delete-app-role",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Changes an app role from a group
 */
export const adminChangeGroupAppRole = <ThrowOnError extends boolean = true>(
  options: Options<AdminChangeGroupAppRoleData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminChangeGroupAppRoleResponses,
    AdminChangeGroupAppRoleErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/change-app-role",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove tenant from group
 *
 * Removes a tenant from a group. Requires admin access.
 */
export const adminRemoveGroupTenant = <ThrowOnError extends boolean = true>(
  options: Options<AdminRemoveGroupTenantData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    AdminRemoveGroupTenantResponses,
    AdminRemoveGroupTenantErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add tenant to group
 *
 * Adds a tenant to a group. Requires admin access.
 */
export const adminAddGroupTenant = <ThrowOnError extends boolean = true>(
  options: Options<AdminAddGroupTenantData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminAddGroupTenantResponses,
    AdminAddGroupTenantErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove role from group
 *
 * Removes a role from a group. Requires admin access.
 */
export const adminRemoveAdminRoleFromGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminRemoveAdminRoleFromGroupData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    AdminRemoveAdminRoleFromGroupResponses,
    AdminRemoveAdminRoleFromGroupErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add role to group
 *
 * Adds a role to a group. Requires admin access.
 */
export const adminAddRoleToGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminAddRoleToGroupData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminAddRoleToGroupResponses,
    AdminAddRoleToGroupErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update role in group
 *
 * Updates a role in a group. Requires admin access.
 */
export const adminUpdateRoleInGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminUpdateRoleInGroupData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    AdminUpdateRoleInGroupResponses,
    AdminUpdateRoleInGroupErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Change group scope type
 *
 * Changes a group's scope type. Requires admin access.
 */
export const adminChangeGroupScopeType = <ThrowOnError extends boolean = true>(
  options: Options<AdminChangeGroupScopeTypeData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    AdminChangeGroupScopeTypeResponses,
    AdminChangeGroupScopeTypeErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/scope-type",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get a user by ID
 */
export const adminGetUser = <ThrowOnError extends boolean = true>(
  options: Options<AdminGetUserData, ThrowOnError>,
) =>
  (options.client ?? client).get<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError>({
    url: "/api/admin/users/{userSub}",
    ...options,
  });

/**
 * Get user data for user details page
 */
export const adminGetUserData = <ThrowOnError extends boolean = true>(
  options: Options<AdminGetUserDataData, ThrowOnError>,
) =>
  (options.client ?? client).get<AdminGetUserDataResponses, AdminGetUserDataErrors, ThrowOnError>({
    url: "/api/admin/users/{userSub}/data",
    ...options,
  });

/**
 * Create new user
 *
 * Creates a new user (internal or external). Requires admin access.
 */
export const adminCreateUser = <ThrowOnError extends boolean = true>(
  options?: Options<AdminCreateUserData, ThrowOnError>,
) =>
  (options?.client ?? client).post<AdminCreateUserResponses, AdminCreateUserErrors, ThrowOnError>({
    url: "/api/admin/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Delete user
 *
 * Deletes a user. Requires admin access.
 */
export const adminDeleteUser = <ThrowOnError extends boolean = true>(
  options: Options<AdminDeleteUserData, ThrowOnError>,
) =>
  (options.client ?? client).delete<AdminDeleteUserResponses, AdminDeleteUserErrors, ThrowOnError>({
    url: "/api/admin/users/{sub}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update user
 *
 * Updates user properties. Requires admin access.
 */
export const adminUpdateUser = <ThrowOnError extends boolean = true>(
  options: Options<AdminUpdateUserData, ThrowOnError>,
) =>
  (options.client ?? client).put<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError>({
    url: "/api/admin/users/{sub}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Request external user password reset
 *
 * Requests a password reset for an external user. Requires admin access.
 */
export const adminRequestPasswordReset = <ThrowOnError extends boolean = true>(
  options: Options<AdminRequestPasswordResetData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminRequestPasswordResetResponses,
    AdminRequestPasswordResetErrors,
    ThrowOnError
  >({
    url: "/api/admin/users/{sub}/password-reset",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove user role
 *
 * Removes a user's role. Requires admin access.
 */
export const adminRemoveUserRole = <ThrowOnError extends boolean = true>(
  options: Options<AdminRemoveUserRoleData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    AdminRemoveUserRoleResponses,
    AdminRemoveUserRoleErrors,
    ThrowOnError
  >({
    url: "/api/admin/users/{sub}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update user role
 *
 * Updates a user's role. Requires admin access.
 */
export const adminUpdateUserRole = <ThrowOnError extends boolean = true>(
  options: Options<AdminUpdateUserRoleData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    AdminUpdateUserRoleResponses,
    AdminUpdateUserRoleErrors,
    ThrowOnError
  >({
    url: "/api/admin/users/{sub}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Change user scope type
 *
 * Changes user scope type and adds default app role accordingly. Requires admin access.
 */
export const adminChangeUserScopeType = <ThrowOnError extends boolean = true>(
  options: Options<AdminChangeUserScopeTypeData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    AdminChangeUserScopeTypeResponses,
    AdminChangeUserScopeTypeErrors,
    ThrowOnError
  >({
    url: "/api/admin/users/{sub}/scope-type",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add project
 *
 * Creates a new project. Requires admin access.
 */
export const adminAddProject = <ThrowOnError extends boolean = true>(
  options?: Options<AdminAddProjectData, ThrowOnError>,
) =>
  (options?.client ?? client).post<AdminAddProjectResponses, AdminAddProjectErrors, ThrowOnError>({
    url: "/api/admin/projects",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Update project
 *
 * Updates project details. Requires admin access.
 */
export const adminUpdateProject = <ThrowOnError extends boolean = true>(
  options: Options<AdminUpdateProjectData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    AdminUpdateProjectResponses,
    AdminUpdateProjectErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove package from project
 *
 * Removes a package from a project. Requires admin access.
 */
export const adminRemovePackageFromProject = <ThrowOnError extends boolean = true>(
  options: Options<AdminRemovePackageFromProjectData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    AdminRemovePackageFromProjectResponses,
    AdminRemovePackageFromProjectErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/packages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add package to project
 *
 * Adds a package to a project. Requires admin access.
 */
export const adminAddPackageToProject = <ThrowOnError extends boolean = true>(
  options: Options<AdminAddPackageToProjectData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminAddPackageToProjectResponses,
    AdminAddPackageToProjectErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/packages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete user from project
 *
 * Removes a user from a project. Requires admin access.
 */
export const adminDeleteUserFromProject = <ThrowOnError extends boolean = true>(
  options: Options<AdminDeleteUserFromProjectData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    AdminDeleteUserFromProjectResponses,
    AdminDeleteUserFromProjectErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add user to project
 *
 * Adds a user to a project. Requires admin access.
 */
export const adminAddUserToProject = <ThrowOnError extends boolean = true>(
  options: Options<AdminAddUserToProjectData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminAddUserToProjectResponses,
    AdminAddUserToProjectErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete group from project
 *
 * Removes a group from a project. Requires admin access.
 */
export const adminDeleteGroupFromProject = <ThrowOnError extends boolean = true>(
  options: Options<AdminDeleteGroupFromProjectData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    AdminDeleteGroupFromProjectResponses,
    AdminDeleteGroupFromProjectErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove project role from user
 *
 * Removes a user's project role. Requires admin access.
 */
export const adminRemoveProjectRoleOfUser = <ThrowOnError extends boolean = true>(
  options: Options<AdminRemoveProjectRoleOfUserData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    AdminRemoveProjectRoleOfUserResponses,
    AdminRemoveProjectRoleOfUserErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/users/{userSub}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add project role to user
 *
 * Adds a project role to a user. Requires admin access.
 */
export const adminAddProjectRoleOfUser = <ThrowOnError extends boolean = true>(
  options: Options<AdminAddProjectRoleOfUserData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminAddProjectRoleOfUserResponses,
    AdminAddProjectRoleOfUserErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/users/{userSub}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Change project role of user
 *
 * Changes a user's project role. Requires admin access.
 */
export const adminChangeProjectRoleOfUser = <ThrowOnError extends boolean = true>(
  options: Options<AdminChangeProjectRoleOfUserData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    AdminChangeProjectRoleOfUserResponses,
    AdminChangeProjectRoleOfUserErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/users/{userSub}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get current user's admin data
 */
export const adminUsersGetMyAdminData = <ThrowOnError extends boolean = true>(
  options?: Options<AdminUsersGetMyAdminDataData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AdminUsersGetMyAdminDataResponses,
    AdminUsersGetMyAdminDataErrors,
    ThrowOnError
  >({ url: "/api/admin/admin-users/me", ...options });

/**
 * List all admin users (filtered by requester scope)
 */
export const adminUsersListAdminUsers = <ThrowOnError extends boolean = true>(
  options?: Options<AdminUsersListAdminUsersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AdminUsersListAdminUsersResponses,
    AdminUsersListAdminUsersErrors,
    ThrowOnError
  >({ url: "/api/admin/admin-users", ...options });

/**
 * Create admin user assignment
 */
export const adminUsersCreateAdminUser = <ThrowOnError extends boolean = true>(
  options?: Options<AdminUsersCreateAdminUserData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    AdminUsersCreateAdminUserResponses,
    AdminUsersCreateAdminUserErrors,
    ThrowOnError
  >({
    url: "/api/admin/admin-users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Revoke admin access
 */
export const adminUsersRevokeAdminAccess = <ThrowOnError extends boolean = true>(
  options: Options<AdminUsersRevokeAdminAccessData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    AdminUsersRevokeAdminAccessResponses,
    AdminUsersRevokeAdminAccessErrors,
    ThrowOnError
  >({ url: "/api/admin/admin-users/{userSub}", ...options });

/**
 * Get specific admin user
 */
export const adminUsersGetAdminUser = <ThrowOnError extends boolean = true>(
  options: Options<AdminUsersGetAdminUserData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    AdminUsersGetAdminUserResponses,
    AdminUsersGetAdminUserErrors,
    ThrowOnError
  >({ url: "/api/admin/admin-users/{userSub}", ...options });

/**
 * Update admin user assignment
 */
export const adminUsersUpdateAdminUser = <ThrowOnError extends boolean = true>(
  options: Options<AdminUsersUpdateAdminUserData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    AdminUsersUpdateAdminUserResponses,
    AdminUsersUpdateAdminUserErrors,
    ThrowOnError
  >({
    url: "/api/admin/admin-users/{userSub}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
